import { api } from "@/api/client";
import type { OneCConnectionView } from "@/types/api";

export interface ConnectionCreate {
  name: string;
  base_url: string;
  username: string;
  password: string;
}

export interface ConnectionUpdate {
  name?: string;
  base_url?: string;
  username?: string;
  password?: string;
  is_default?: boolean;
}

export interface TestConnectionResult {
  ok: boolean;
  detail: string;
  status_code: number | null;
}

export async function listConnections(): Promise<OneCConnectionView[]> {
  const { data } = await api.get<OneCConnectionView[]>("/connections");
  return data;
}

export async function createConnection(body: ConnectionCreate): Promise<OneCConnectionView> {
  const { data } = await api.post<OneCConnectionView>("/connections", body);
  return data;
}

export async function updateConnection(
  id: string,
  body: ConnectionUpdate,
): Promise<OneCConnectionView> {
  const { data } = await api.put<OneCConnectionView>(`/connections/${id}`, body);
  return data;
}

export async function deleteConnection(id: string, force = false): Promise<void> {
  await api.delete(`/connections/${id}`, { params: force ? { force: true } : undefined });
}

export async function testConnection(id: string): Promise<TestConnectionResult> {
  const { data } = await api.post<TestConnectionResult>(`/connections/${id}/test`);
  return data;
}
